"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
window.addEventListener("load", function () {
    (0, util_1.setupNoviceFlowEventListeners)();
    (0, util_1.setupResultsFlowEventListeners)();
});
//# sourceMappingURL=module.js.map